module.exports = __webpack_public_path__ + "static/media/picture.9317ccce.svg";